<template>
  <div class="modal fade" @keyup.esc.prevent="closeModal" tabindex="-1" id="locationPriceModal" aria-labelledby="locationPriceModalLabel" aria-hidden="false">
    <div class="modal-dialog modal-dialog-scrollable">
      <div class="modal-content shadow-none">
        <div class="modal-header">
          <h5 class="modal-title">Изменить цену</h5>
          <div @click="closeModal" class="btn btn-icon btn-sm btn-active-light-primary ms-2">
            <i class="ki-duotone ki-cross fs-2x"><span class="path1"></span><span class="path2"></span></i>
          </div>
        </div>
        <div class="modal-body">
          <p class="text-muted small mb-4">Укажите новую цену только для тех коннекторов, которые нужно обновить.</p>
          <div v-for="(connector, index) in formConnectors" :key="connector.connectorId" class="rounded border bg-light-secondary p-3 mb-3">
            <div class="mb-2 fw-bold">{{ connector.label || 'Коннектор ' + (index + 1) }}</div>
            <div class="mb-2 text-gray-600 small">connectorId: {{ connector.connectorId }}</div>
            <input-field
              v-model.number="connector.oldPrice"
              :id="'oldPrice-' + connector.connectorId"
              :name="'oldPrice-' + connector.connectorId"
              placeholder="Старая цена (сум)"
              type="number"
              mb="2"
            />
            <input-field
              v-model.number="connector.newPrice"
              :id="'price-' + connector.connectorId"
              :name="'price-' + connector.connectorId"
              placeholder="Новая цена (сум)"
              type="number"
              mb="0"
            />
          </div>
          <div v-if="errorMessage" class="alert alert-danger d-flex align-items-center mb-0 mt-3">
            <i class="ki-outline ki-information-5 fs-2hx text-danger me-3"></i>
            <span>{{ errorMessage }}</span>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" @click="closeModal" class="btn btn-light btn-sm">Отмена</button>
          <button type="button" class="btn btn-primary btn-sm" :disabled="!hasChanges || loading" @click="submit">
            {{ loading ? 'Сохранение...' : 'Сохранить' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputField from '@/components/Fields/InputField'
import axios from 'axios'
import { notify } from '@kyvg/vue3-notification'

export default {
  name: 'LocationPriceModal',
  components: { InputField },
  props: {
    locationId: { type: [Number, String], required: true },
    connectors: { type: Array, default: () => [] },
  },
  data() {
    return {
      formConnectors: [],
      loading: false,
      errorMessage: '',
    }
  },
  computed: {
    hasChanges() {
      return this.formConnectors.some(
        c => c.newPrice !== '' && c.newPrice !== null && Number(c.newPrice) !== Number(c.oldPrice)
      )
    },
  },
  watch: {
    connectors: {
      immediate: true,
      handler(connectors) {
        this.formConnectors = (connectors || []).map((c) => ({
          connectorId: c.id ?? c.connectorId,
          label: c.label,
          oldPrice: c.price ?? c.oldPrice ?? null,
          newPrice: '',
        }))
        this.errorMessage = ''
      },
    },
  },
  mounted() {
    setTimeout(() => {
      const el = document.getElementById('locationPriceModal')
      if (el) {
        el.addEventListener('mousedown', (event) => {
          if (event.target.classList.contains('modal')) this.closeModal()
        })
      }
    }, 10)
  },
  methods: {
    closeModal() {
      this.$emit('close')
      const modalEl = document.getElementById('locationPriceModal')
      const instance = bootstrap.Modal.getInstance(modalEl)
      if (instance) instance.hide()
    },
    buildPayload() {
      const connectorPrices = this.formConnectors
        .filter((c) => {
          const newVal = Number(c.newPrice)
          return c.newPrice !== '' && c.newPrice !== null && !Number.isNaN(newVal) && newVal !== Number(c.oldPrice)
        })
        .map((c) => {
          const oldVal = c.oldPrice
          const num = Number(oldVal)
          const oldNum = (oldVal !== '' && oldVal != null && !Number.isNaN(num) && num !== 0) ? num : null
          return {
            connectorId: Number(c.connectorId),
            price: Number(c.newPrice),
            oldPrice: oldNum,
          }
        })
      return { connectorPrices }
    },
    submit() {
      if (!this.hasChanges) return
      const payload = this.buildPayload()
      if (!payload.connectorPrices.length) return
      this.loading = true
      this.errorMessage = ''
      axios
        .put(`/station-processing-service/api/admin/v1/locations/${this.locationId}/price`, payload)
        .then((res) => {
          notify({
            duration: 3000,
            type: 'success',
            title: 'Успешно',
            text: 'Цены обновлены.',
          })
          this.$emit('success', res.data)
          this.closeModal()
        })
        .catch((error) => {
          const msg = error?.response?.data?.errorDescription ?? error?.response?.data?.message ?? error.message
          this.errorMessage = msg || 'Ошибка при сохранении'
          notify({
            duration: 5000,
            type: 'error',
            title: 'Ошибка',
            text: msg,
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
